import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { useDataProvider } from '@/components/flow/components/DataProvider/useDataProvider';
import { useCardTrialSizeItemPrices } from '@/components/product-selection/hooks/useCardTrialSizeItemPrices';
import { usePurchaseContext } from '@/components/product-selection/hooks/usePurchaseContext';
import { DATA_KEYS } from '@/consts/dataKeys';
import {
  getCardFullSizeItemPrices,
  getDisplayPrices,
} from '@/helpers/productSelectionAndCheckout/helpers';
import {
  type Card,
  type Flags,
} from '@/types/productSelectionAndCheckout/types';

const getMonthlyCopy = (flags: Flags, modalCard: Card) => {
  if (flags.lowerFillSizeProductVariants) {
    return null;
  }

  if (flags.isTwoMonthFirstShipment) {
    return ' (2-month supply)';
  } else if (!modalCard.notMonthly) {
    return ' (1-month supply)';
  }

  return null;
};

export const ModalPricingVolumeAndProductOptionSelector = ({
  className,
  modalCard,
}: {
  className?: string;
  modalCard: Card;
}) => {
  const { flags, fullSizeItemPrices } = useDataProvider(
    DATA_KEYS.productSelection,
  );
  const { purchaseContext } = usePurchaseContext();
  const cardTrialSizeItemPrices = useCardTrialSizeItemPrices(modalCard);

  const cardFullSizeItemPrices = getCardFullSizeItemPrices(
    modalCard,
    fullSizeItemPrices,
  );
  const { modal } = modalCard;

  const { price, salePrice } = getDisplayPrices(
    cardTrialSizeItemPrices,
    cardFullSizeItemPrices,
    undefined,
    purchaseContext,
  );

  return (
    <div className={className || 'cur-mt-4'}>
      {salePrice && (
        <>
          <Typography className="cur-inline" weight="bold">
            {salePrice.toUpperCase()}
          </Typography>{' '}
        </>
      )}
      <Typography className="cur-inline cur-text-disabled">
        <span className="cur-line-through">{price}</span>
      </Typography>{' '}
      {modalCard.isRx && flags.isTwoMonthTrialWith50PctOff && (
        <Typography className="cur-inline cur-text-brand">
          (1 month FREE!){' '}
        </Typography>
      )}
      {modalCard.isRx && flags.isTwoMonthTrialWith1995Rx && (
        <Typography className="cur-inline cur-text-brand">
          (1+ month FREE!){' '}
        </Typography>
      )}
      {!modalCard.isRx && flags.isTwoMonthTrialWith50PctOff && (
        <Typography className="cur-inline cur-text-brand">
          (50% off){' '}
        </Typography>
      )}
      <Typography className="cur-inline">
        • {modal.volume}
        {modal.selectableOptionName ? `, ${modal.selectableOptionName}` : ''}
        {getMonthlyCopy(flags, modalCard)}
      </Typography>
    </div>
  );
};
